export default [
	{  // 经销商管理
		path: 'seller_user_list',
		name: 'm_seller_stationed_user',
		component: () => import('@/pages/seller/stationed_user_list')
	}, {  // 经销商权限角色列表
		path: 'seller_auth_list',
		name: 'm_seller_auth',
		component: () => import('@/pages/seller/stationed_auth_list')
	}, {  // 新建经销商权限角色
		path: 'seller_auth_add',
		name: 'seller_auth_add',
		meta: {
			title: '新建经销商角色'
		},
		component: () => import('@/pages/seller/stationed_auth_add')
	}, {  // 编辑商经销商权限角色
		path: 'seller_auth_edit/:id',
		name: 'seller_auth_edit',
		meta: {
			title: '编辑经销商角色'
		},
		props: route => route.params,
		component: () => import('@/pages/seller/stationed_auth_edit')
	}, {  // 经销商商品列表
		path: 'seller_product_list',
		name: 'm_seller_product_list',
		component: () => import('@/pages/seller/product_list')
	}, {  // 经销商订单列表
		path: 'seller_order_list',
		name: 'm_seller_order_sell',
		props: route => route.query,
		component: () => import('@/pages/seller/order_list')
	}, {  // 经销商退款单列表
		path: 'seller_refund_list',
		name: 'm_seller_order_refund',
		props: route => route.query,
		component: () => import('@/pages/seller/refund_list')
	}, {  // 经销商售后单列表
		path: 'seller_return_list',
		name: 'm_seller_order_return',
		props: route => route.query,
		component: () => import('@/pages/seller/return_list')
	},{  // 经销商交易统计
		path: 'seller_statistic_trans_list',
		name: 'm_seller_statistic_trans',
		component: () => import('@/pages/seller/statistic_trans')
	}, {  // 经销商商品统计
		path: 'seller_statistic_product_list',
		name: 'm_seller_statistic_product',
		component: () => import('@/pages/seller/statistic_product')
	}
	, {  // 经销商收支记录
		path: 'seller_account_record',
		name: 'm_seller_account_record',
		props: route => route.query,
		component: () => import('@/pages/seller/account_record_list')
	}, {  // 经销商收支记录详情
		path: 'seller_account_record_detail/:id',
		name: 'seller_account_record_detail',
		meta: {
			title: '会员收支记录详情'
		},
		props: route => route.params,
		component: () => import('@/pages/seller/account_record_detail')
	}, {  // 经销商补扣款
		path: 'seller_account_supdeduct',
		name: 'm_seller_account_supdeduct',
		component: () => import('@/pages/seller/account_supdeduct_list')
	}, {  // 经销商补扣款详情
		path: 'seller_account_supdeduct_detail/:id',
		name: 'seller_account_supdeduct_detail',
		meta: {
			title: '经销商补扣款详情'
		},
		props: route => route.params,
		component: () => import('@/pages/seller/account_supdeduct_detail')
	}, {  // 经销商提现
		path: 'seller_account_extract',
		name: 'm_seller_account_extract',
		component: () => import('@/pages/seller/account_extract_list')
	}, {  // 经销商提现详情
		path: 'seller_account_extract_detail/:id',
		name: 'seller_account_extract_detail',
		meta: {
			title: '经销商提现详情'
		},
		props: route => route.params,
		component: () => import('@/pages/seller/account_extract_detail')
	}, {  // 经销商订单清分列表
		path: 'seller_settlement',
		name: 'm_seller_order_settlement',
		component: () => import('@/pages/seller/order_settlement_list')
	}
];